import { useQuery } from '@tanstack/react-query'

import { caaInstance } from '@/modules/caa'
import { AvailabilityTypes } from '@/modules/caa/domain/models/AvailabilityTypes'
import { CAATypes } from '@/modules/caa/domain/models/CAATypes'

export function getListCAAForOperationalQueryKey(params: {
  date: string
  patientId?: string
  personaName?: string
  availability?: AvailabilityTypes
  typeCAA?: CAATypes
}) {
  const baseKey = ['listCAAForOperational']
  return params ? [...baseKey, params] : [...baseKey]
}

export function useListCAAForOperationalQuery({
  date,
  patientId,
  personaName,
  availability,
  typeCAA,
  enabled
}: {
  date: string
  patientId?: string
  personaName?: string
  availability?: AvailabilityTypes
  typeCAA?: CAATypes
  enabled: boolean
}) {
  return useQuery({
    queryKey: getListCAAForOperationalQueryKey({
      date,
      patientId,
      personaName,
      availability,
      typeCAA
    }),
    queryFn: async () => {
      return await caaInstance.listCAAForOperational({
        date,
        patientId,
        personaName,
        availability,
        typeCAA
      })
    },
    enabled: !!date && enabled
  })
}
